import React, { useState } from 'react'
import DraggableImage from './DraggableImage'
import PeekCarouselSlider from '../PeekCarouselSlider'
import ZoomInModal from '@site/components/atoms/ZoomInModal'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'


const generateCarouselImages = ( { images, onClick }: PeekCarousel.GenerateImagesProps ): React.ReactElement[] => {
  return images.map( ( imageObject: PeekCarousel.Image, index: number ) => (
    <DraggableImage
      key={ `draggable-image-${index}` }
      image={ imageObject }
      onClick={ () => onClick( imageObject ) }
    />
  ) )
}

const PeekCarousel: React.FC<PeekCarousel.Props> = ( { images, autoPlay } ): React.ReactElement => {
  const [ modalImage, setModalImage ] = useState<PeekCarousel.Image | null>( null )
  const [ showModal, setShowModal ] = useState<boolean>( false )

  return (
    <>
      <PeekCarouselSlider autoPlay={ autoPlay }>
        { generateCarouselImages( {
          images,
          'onClick': ( image ) => {
            setModalImage( image )
            setShowModal( true )
          }
        }
        ) }
      </PeekCarouselSlider>
      <ZoomInModal
        image={ modalImage as PeekCarousel.Image }
        showModal={ showModal }
        onClose={ () => {
          setShowModal( false )
          setModalImage( null )
        } }
      />
    </>
  )
}

namespace PeekCarousel {
  export type Image = StrapiFile & { localFile?: any }
  export interface Props {
    images: Array<Image>
    autoPlay: boolean
  }
  export interface GenerateImagesProps {
    images: Image[],
    onClick: ( image: Image ) => void
  }
}

export default PeekCarousel
